var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      staticClass: "user-display-btn",
      attrs: { type: "default", size: "small" },
    },
    [
      _vm.user
        ? [
            _c("div", { staticClass: "userInfo" }, [
              _c("p", { staticClass: "mb-2" }, [
                String(_vm.user.gender) == "0"
                  ? _c("span", [_vm._v("آقای ")])
                  : _vm._e(),
                String(_vm.user.gender) == "1"
                  ? _c("span", [_vm._v("خانم ")])
                  : _vm._e(),
                _vm.user.firstName
                  ? _c("span", [_vm._v(_vm._s(_vm.user.firstName + " "))])
                  : _vm._e(),
                _c("span", [_vm._v(_vm._s(_vm.user.name))]),
              ]),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.user.mobile)),
              ]),
            ]),
          ]
        : _c("p", { staticClass: "mb-0" }, [_vm._v("سلام")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }